import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["childNodeIds"];
import { immerable } from 'immer';
import GridNode from './GridNode';
import { GRID_NODE_TYPES, STACK_DIRECTIONS } from './constants';
import { mergeIntoPath } from './utils';
import { isGridContainerLayout, isStackContainerLayout } from './typenameUtils';
import { ContainerTypename } from '../../__generated__/chirp/com/hubspot/content/grid/layouts/rpc/GridLayoutsRpc';
export default class ContainerNode extends GridNode {
  constructor(_ref) {
    let {
        childNodeIds = []
      } = _ref,
      containerNodeParams = _objectWithoutPropertiesLoose(_ref, _excluded);
    super(containerNodeParams);
    this[immerable] = true;
    this._childNodeIds = childNodeIds;
  }
  cloneAndChange(containerNodeParams) {
    const {
      id,
      childNodeIds,
      parentNodeId,
      value,
      treeRef
    } = containerNodeParams;
    const newNodeParams = {
      id: id !== null && id !== void 0 ? id : this._id,
      type: GRID_NODE_TYPES.CONTAINER,
      treeRef: treeRef !== null && treeRef !== void 0 ? treeRef : this._treeRef,
      childNodeIds: childNodeIds !== null && childNodeIds !== void 0 ? childNodeIds : this._childNodeIds,
      parentNodeId: parentNodeId !== null && parentNodeId !== void 0 ? parentNodeId : this._parentNodeId,
      value: value !== null && value !== void 0 ? value : this._value
    };
    return newNodeParams.treeRef.createNewContainer(newNodeParams);
  }
  serializeNode(options) {
    return Object.assign({}, this.getValue(), {
      children: this.getChildNodes().map(child => child.serializeNode(options)),
      __typename: ContainerTypename
    });
  }
  exportNode() {
    return {
      id: this.getId(),
      value: this.getValue(),
      parentNodeId: this.getParentNodeId(),
      childNodeIds: [...this.getChildNodeIds()]
    };
  }
  getChildNodes() {
    return this.getChildNodeIds().map(childNodeId => this.getTree().findNode(childNodeId));
  }
  mergeIntoValue(partialValue, path) {
    return this.cloneAndChange({
      value: mergeIntoPath(this._value, partialValue, path)
    });
  }
  mergeIntoStylesByPath(partialStyles, path) {
    return this.cloneAndChange({
      value: Object.assign({}, this._value, {
        styles: mergeIntoPath(this.getStyles(), partialStyles, path)
      })
    });
  }
  mergeIntoStyles(partialStyles) {
    return this.cloneAndChange({
      value: Object.assign({}, this._value, {
        styles: mergeIntoPath(this.getStyles(), partialStyles, ['breakpointStyles'])
      })
    });
  }
  isChildOfSection() {
    return this.getParentNode().isSection();
  }
  getLayout() {
    return this.getValue().layout;
  }
  getContainerLayout(breakpoint = 'default') {
    return this.getLayout().layout[breakpoint] || this.getLayout().layout.default;
  }
  isGrid(breakpoint = 'default') {
    return isGridContainerLayout(this.getContainerLayout(breakpoint));
  }
  isStack(breakpoint = 'default') {
    return isStackContainerLayout(this.getContainerLayout(breakpoint));
  }
  isHorizontalStack(breakpoint = 'default') {
    const stackLayout = this.getContainerLayout(breakpoint);
    return isStackContainerLayout(stackLayout) && stackLayout.direction === STACK_DIRECTIONS.HORIZONTAL;
  }
  isVerticalStack(breakpoint = 'default') {
    const stackLayout = this.getContainerLayout(breakpoint);
    return isStackContainerLayout(stackLayout) && stackLayout.direction === STACK_DIRECTIONS.VERTICAL;
  }
  getBreakpointStyles(breakpoint = 'default') {
    const defaultStyles = Object.assign({}, this.getStyles().breakpointStyles.default);
    if (breakpoint !== 'default') {
      return Object.assign({}, defaultStyles, this.getStyles().breakpointStyles[breakpoint]);
    }
    return defaultStyles;
  }
  getStyles() {
    return this.getValue().styles;
  }
  getLabel() {
    var _this$getValue$label;
    return (_this$getValue$label = this.getValue().label) !== null && _this$getValue$label !== void 0 ? _this$getValue$label : '';
  }
}